import { render, staticRenderFns } from "./TabelaDevedor.vue?vue&type=template&id=a64374ca&scoped=true&"
import script from "./TabelaDevedor.vue?vue&type=script&lang=js&"
export * from "./TabelaDevedor.vue?vue&type=script&lang=js&"
import style0 from "./TabelaDevedor.vue?vue&type=style&index=0&id=a64374ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64374ca",
  null
  
)

export default component.exports